const ID = {
  id: 'id',
  label: 'order.list.id',
  permission: 'order:get',
  type: 'text',
  link: {
    to: 'ordersDetail',
    params: { id: 'id' },
    query: ['created_at']
  }
}
const CODE = {
  id: 'code',
  label: 'order.list.code',
  type: 'text'
}
const NAME = {
  id: 'customer.name',
  label: 'order.list.name',
  permission: 'customer:get',
  type: 'text',
  link: {
    to: 'customersDetail',
    params: { id: 'order.customer.id', tab: 'info' },
    query: ['created_at']
  }
}
const AMOUNT = {
  id: 'amount',
  label: 'order.list.amount',
  type: 'text'
}
const STATUS = {
  id: 'status',
  label: 'order.list.status',
  type: 'status'
}
const CREATED_AT = {
  id: 'created_at',
  label: 'order.list.created-at',
  type: 'date',
  format: 'dateAndHour'
}

const FIELDS = [ID, CODE, NAME, AMOUNT, STATUS, CREATED_AT]

export { FIELDS }
